import * as React from "react";
import { Button } from "@mui/material";
import { useForgotPasswordDialog } from "./ForgotPasswordDialog";
import { useLanguage } from "./Language";

export const ForgotPasswordButton = () => {
  const { openDialog } = useForgotPasswordDialog();
  const { translate } = useLanguage();

  return (
    <Button type="button" onClick={openDialog}>
      {translate("forgotPassword")}
    </Button>
  );
};
